{
    "translation": {
        "test": "texto prueba fr"
    }
}
